export default "https://dakcheck.solease.nl/static/media/info.2e471a44.svg";